import FileUpload from './FileUpload';
import { FileMetadata, UploadedFileResponse } from '../../api/types/cms';
import { useTranslation } from '../../contexts/TranslationContext';
import { useSnackbar } from 'notistack';

type FileUploadModalProps = {
    open: boolean;
    onClose?: () => void;
    onSuccess?: (createdFile: FileMetadata | null) => void;
    onRefresh?: () => void;
    uploadToPool?: string;
    contentName?: string;
};
export default function FileUploadModal({
    open,
    onSuccess,
    onClose,
    onRefresh,
    uploadToPool,
    contentName,
}: FileUploadModalProps) {
    const { enqueueSnackbar } = useSnackbar();
    const { translate } = useTranslation();

    const onUploadSuccess = (createdFile: FileMetadata | null) => {
        if (createdFile) {
            enqueueSnackbar(translate('messages.uploaded'), {
                variant: 'success',
            });
        }
        onSuccess && onSuccess(createdFile);
    };

    return (
        <FileUpload
            hideButton
            hideFiles
            directOpen={open}
            onSuccess={file =>
                onUploadSuccess(file as UploadedFileResponse | null)
            }
            onClose={onClose}
            uploadToPool={uploadToPool}
            contentName={contentName}
        />
    );
}
